module.exports = __webpack_public_path__ + "static/media/29FUNOV8.0d9c5c99.jpg";